/*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
import { MODAL_ACCOUNT_ADD, MODAL_ADD_ACCOUNT_NAVLIST } from 'constants/modal';
import { CREDENTIAL_NOTE_PARENT as CREDENTIAL_NOTE_NODE, SEARCH2 } from 'constants/ids';
import { PAUSE_SCAN as ID_PAUSE_SCAN } from 'constants/ids';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import GoogleButton from 'react-google-button';
import { Button } from '@nettoken/components';
import { isProduction } from '@nettoken/env';
import { handleAriaKeyPress, i18nRenderLines, noop } from '@nettoken/helpers';
import { GOOGLE, MICROSOFT } from 'main/emailScan';
import colours from 'environment/colours';
import ActionBar from 'Modal/ActionBar';
import AppsPreview from 'AppsPreview';
import Counter from 'Counter';
import Tabs from 'Modal/tabs';
import Tooltip from 'Tooltip';
import NettoY from 'assets/images/netto-circle-only.svg';
import Styles from 'Modal/style.css';
import cross from '../../../../assets/images/cross.svg';
import leftsvg from '../../../../assets/images/left.svg';
import LeftArrowIcon from '../../../ActionIcons/LeftArrowIcon';
import CancelIcon from '../../../ActionIcons/CancelIcon';
import ClearIcon from '../../../ActionIcons/ClearIcon';

class ModalEmailScanContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      btnDisable: false,
    };
    this.handleClickGoogleButton = this.handleClickGoogleButton.bind(this);
  }

  renderLines(text) {
    return text.map((line, index) => (
      <p key={index} className={Styles.emailScanDisclaimer} style={{
        fontSize: '14px',
      }}>
        {line}
      </p>
    ));
  }

  content() {
    switch (this.props.step) {
      case 'confirm':
        return this.confirm();
      case 'awaitingsignin':
      case 'scan':
        return this.scan();

      case 'preview':
        return this.preview();

      case 'signin':
      default:
        return this.signIn();
    }
  }

  handleClickGoogleButton(event) {
    if (this.props.hasConsent && handleAriaKeyPress(event)) {
      this.props.onClickGoogleButton();
    }
  }

  preview() {
    const { hasNewAccounts, t } = this.props;
    return (
      <form
        action="/"
        className={classNames({
          [Styles.formEmailScanPreview]: hasNewAccounts,
          [Styles.formEmailScan]: !hasNewAccounts,
          [Styles._fixedActions]: true,
          [Styles.stickyMinHeightBackground]: !(this.props.step == 'preview'),
          [Styles.stickyPaddingTop]: !(this.props.step == 'preview'),
        })}
        method="post"
        onSubmit={this.props.onSubmit}>
        {hasNewAccounts ?
          <div>
            <div className={Styles.stickyfixedForm2} style={{ backgroundColor: '#f6f6f6' }}>
              <div className={`${Styles.searchWrapper} ${Styles.stickySearchHeader2}`}>
                <input
                  aria-label={t('placeholder.search')}
                  className={classNames(Styles.search, Styles._preview, Styles.search_select)}
                  onChange={this.props.onChangeSearch}
                  placeholder={`${t('placeholder.search')}...`}
                  role="search"
                  type="text"
                  id={SEARCH2}
                  value={this.props.query} />
                {this.props.query.length > 0 ?
                  <ClearIcon onClickClearSearch={this.props.onClickClearSearch} /> : null}
              </div>
              <div className={`${Styles.actions2} ${Styles.stickyActionBar44}`}></div>
              <div className={`${Styles.stickyAppList44}`}>
                <AppsPreview
                  apps={this.props.filteredApps}
                  isEmailEditable={true}
                  onChange={this.props.onChange}
                  onClickPasswordToggle={this.props.onClickPasswordToggle}
                  onSelectApp={this.props.onSelectApp}
                  top={true}
                  passwordList={this.props.passwordList}
                  selectedApps={this.props.selectedApps}
                  unsortedId={this.props.unsortedId}
                  split={true}
                />
              </div>
            </div>
            <div className={classNames({
              [Styles.actions]: true,
              [Styles.accountCounter]: true,
              [Styles.actionsFixed]: true,
            })} style={{ maxWidth: '780px', width: '92vw' }}>
              <span>
                <Counter
                  noGreyBar={true}
                  colour="#fff"
                  count={this.props.selectedApps.size}
                  font="sm"
                  label={'Accounts'}
                  size={32}
                />
              </span>

              <div>
                <Button
                  className={classNames({
                    [Styles.button]: true,
                    [Styles.notDisabled]: this.props.canSubmit,
                  })}
                  style={{ backgroundColor: this.state.btnDisable ? '#f8f8f8 !important' : '#FFF466' }}
                  disabled={!this.props.canSubmit || this.props.submitting || this.state.btnDisable}
                  loaderSize={20}
                  loading={this.props.editAccountProccessing}
                  onClick={e => {
                    this.props.onSubmit(e);
                    return true;
                  }}
                  type="submit"
                  value={t('global.add')} />
              </div>
            </div>
            </div> : <p className={Styles.emailScanDisclaimer} style={{
              marginTop: '-15px', paddingBottom: '74px',
            }}>
            {i18nRenderLines(t('modal.importPreview.noNewAccounts'))}
          </p>
        }
        { hasNewAccounts ? '' : <ActionBar
            isFromFile={true}
            showSelected={true}
            showDoneBtn={true}
            onCancel={this.props.onCancel}
            selected={this.props.selectedApps.size}
            submitting={this.props.loading}
            onClickBackHandler={this.props.onClickBackHandler}
            disableInPreview={this.props.disableInPreview}
            t={t} />
        }
      </form>
    );
  }

  scan() {
    const { t, step } = this.props;
    return (
      <form
        action="/"
        className={Styles.formEmailScan}
        method="post"
        onSubmit={this.props.onSubmit}>

        <p className={`${Styles.emailScanDisclaimer} ${Styles._center}`}>
          {this.props.email}
        </p>

        {step === 'awaitingsignin' ?
        <span className={`${Styles.loader} ${Styles.shiftDown}`} /> :
          <React.Fragment>
            <Counter
              noGreyBar={true}
              colour="#fff"
              background={colours.cWhite}
              className={`${Styles.emailScanCounter} ${Styles.emailMarginLeft}`}
              colour="cPrimary"
              rotation={true}
              count={this.props.foundAccounts} />

            <p className={`${Styles.emailScanDisclaimer} ${Styles._center} ${Styles._push}`}>
              {t('modal.emailScan.resultsFound')}
            </p>
          </React.Fragment>}
        {this.renderMessage()}

        <div className={classNames({
          [Styles.actions]: true,
          [Styles.right]: true,
        })}
          id={ID_PAUSE_SCAN}
        >
          <Button
            className={Styles.button}
            disabled={!this.props.canPause}
            onClick={this.props.onPauseOrResume}
            value={t(this.props.isPaused ? 'global.resume' : 'global.pause')} />

            <Button
              className={classNames({
                [Styles.button]: true,
                [Styles.lastChild]: true,
                [Styles.notDisabled]: this.props.canSubmit,
              })}
              disabled={!this.props.canSubmit}
              loaderSize={20}
              loading={this.props.submitting}
              type="submit"
              value='Preview' />
        </div>
      </form>
    );
  }

  renderMessage() {
    const { error, step, t } = this.props;

    let text = error;
    if (step === 'awaitingsignin') {
      text = t('modal.emailScan.disclaimerPopup');
    }
    else if (!text) {
      text = t('modal.emailScan.processing');
    }
    return (
      <p className={classNames({
        [Styles.emailScanDisclaimer]: true,
        [Styles._center]: true,
        [Styles._danger]: error,
      })}>
        {text}
      </p>
    );
  }

  signIn() {
    const { isWaiting, t } = this.props;
    return (
      <form
        action="/"
        className={Styles.formEmailScan}
        method="post">
        <div className={Styles.emailUploadWrapper} id={CREDENTIAL_NOTE_NODE}>

          <p className={Styles.emailScanDisclaimer}>
            Search for accounts you have signed up to with a specific email address.
          </p>

          <ol className={classNames({
            [Styles.emailScanDisclaimer]: true,
            [Styles.numList]: true,
          })}>
            <li>Sign in with an email below to enable temporary access</li>
            <li>Initiate the private, one-time search*</li>
            <li>Preview the list of accounts found</li>
            <li>Select and add accounts</li>
          </ol>

        <p className={Styles.emailScanDisclaimer}>
          <a
            className={Styles.fromFilelinkImage}
            href='https://www.youtube.com/watch?v=58Dh-my6H_s'
            target ="_blank"
            rel="noopener noreferrer" >
            <svg width="30px" height="30px" viewBox="0 0 20 14" version="1.1"
            className={Styles.icon}>
              <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="Dribbble-Light-Preview" transform="translate(-300.000000, -7442.000000)" fill="#000000">
                      <g id="icons" transform="translate(56.000000, 160.000000)">
                          <path d="M251.988432,7291.58588 L251.988432,7285.97425 C253.980638,7286.91168 255.523602,7287.8172 257.348463,7288.79353 C255.843351,7289.62824 253.980638,7290.56468 251.988432,7291.58588 M263.090998,7283.18289 C262.747343,7282.73013 262.161634,7282.37809 261.538073,7282.26141 C259.705243,7281.91336 248.270974,7281.91237 246.439141,7282.26141 C245.939097,7282.35515 245.493839,7282.58153 245.111335,7282.93357 C243.49964,7284.42947 244.004664,7292.45151 244.393145,7293.75096 C244.556505,7294.31342 244.767679,7294.71931 245.033639,7294.98558 C245.376298,7295.33761 245.845463,7295.57995 246.384355,7295.68865 C247.893451,7296.0008 255.668037,7296.17532 261.506198,7295.73552 C262.044094,7295.64178 262.520231,7295.39147 262.895762,7295.02447 C264.385932,7293.53455 264.28433,7285.06174 263.090998,7283.18289" id="youtube-[#168]"></path>
                      </g>
                  </g>
              </g>
          </svg>
          </a>
          Steps on <a className={Styles.anchorfromFileLabel} href='https://www.youtube.com/watch?v=58Dh-my6H_s' target="_blank" >how to add accounts from an Outlook email.</a>
        </p>
          <input
            checked={this.props.hasConsent}
            className={Styles.inputRadioElement}
            id="consent"
            onChange={this.props.onChangeConsent}
            type="checkbox" />

          {this.props.error && <p className={`${Styles.errorText} ${Styles.withPadding}`}>
            {this.props.error}
          </p>}

          <label
            className={`${Styles.itemContent} ${Styles.emailScanConsent}`}
            htmlFor="consent">
            <span className={Styles.labelList}>
              {t('modal.emailScan.consent')}
            </span>
            <div className={Styles.inputRadioBorder} />
          </label>

          {
            isWaiting === GOOGLE ?
              <span className={`${Styles.loader} ${Styles.shiftDown}`} /> :
              <Tooltip content='Coming soon!' placement='right' trigger={!isProduction ? [] : 'hover'}>
                <GoogleButton
                  className={`${Styles.socialButton} ${Styles.googleButton}`}
                  disabled={
                    !this.props.hasConsent || (isWaiting && isWaiting !== GOOGLE) || isProduction
                  }
                  onClick={this.props.onClickGoogleButton}
                  onKeyDown={this.handleClickGoogleButton}
                  type="light" />
              </Tooltip>
          }
          {
            isWaiting === MICROSOFT ?
              <span className={`${Styles.loader} ${Styles.shiftDown}`} /> :
              <button
                aria-label={t('modal.emailScan.signInWith', { provider: MICROSOFT })}
                className={Styles.socialButton}
                disabled={!this.props.hasConsent || (isWaiting && isWaiting !== MICROSOFT)}
                onClick={this.props.onClickMicrosoftButton}
                type="button">
                <svg
                  viewBox="0 0 215 41"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    className={Styles.socialLabel}
                    fill="#5e5e5e"
                    d="M45.812 25.082v-1.794a2.849 2.849 0 0 0 .576.4 4.5 4.5 0 0 0 .707.3 5.513 5.513 0 0 0 .747.187 3.965 3.965 0 0 0 .688.065 2.937 2.937 0 0 0 1.637-.365 1.2 1.2 0 0 0 .538-1.062 1.16 1.16 0 0 0-.179-.649 1.928 1.928 0 0 0-.5-.5 5.355 5.355 0 0 0-.757-.435q-.437-.209-.935-.436c-.356-.19-.687-.383-1-.578a4.358 4.358 0 0 1-.8-.648 2.728 2.728 0 0 1-.534-.8 2.6 2.6 0 0 1-.194-1.047 2.416 2.416 0 0 1 .333-1.285 2.811 2.811 0 0 1 .879-.9 4.026 4.026 0 0 1 1.242-.528 5.922 5.922 0 0 1 1.42-.172 5.715 5.715 0 0 1 2.4.374v1.721a3.832 3.832 0 0 0-2.3-.645 4.106 4.106 0 0 0-.773.074 2.348 2.348 0 0 0-.689.241 1.5 1.5 0 0 0-.494.433 1.054 1.054 0 0 0-.19.637 1.211 1.211 0 0 0 .146.608 1.551 1.551 0 0 0 .429.468 4.276 4.276 0 0 0 .688.414c.271.134.584.28.942.436q.547.285 1.036.6a4.881 4.881 0 0 1 .856.7 3.015 3.015 0 0 1 .586.846 2.464 2.464 0 0 1 .217 1.058 2.635 2.635 0 0 1-.322 1.348 2.608 2.608 0 0 1-.868.892 3.82 3.82 0 0 1-1.257.5 6.988 6.988 0 0 1-1.5.155c-.176 0-.392-.014-.649-.04s-.518-.067-.787-.117a7.772 7.772 0 0 1-.761-.187 2.4 2.4 0 0 1-.578-.269zM55.129 16.426a1.02 1.02 0 0 1-.714-.272.89.89 0 0 1-.3-.688.916.916 0 0 1 .3-.7 1.008 1.008 0 0 1 .714-.278 1.039 1.039 0 0 1 .732.278.909.909 0 0 1 .3.7.9.9 0 0 1-.3.678 1.034 1.034 0 0 1-.732.282zm.842 9.074h-1.7V18h1.7zM65.017 24.9q0 4.131-4.153 4.131a6.187 6.187 0 0 1-2.556-.491v-1.554a4.726 4.726 0 0 0 2.337.7 2.342 2.342 0 0 0 2.672-2.628v-.818h-.029a2.947 2.947 0 0 1-4.742.436 4.041 4.041 0 0 1-.838-2.684 4.738 4.738 0 0 1 .9-3.04 3 3 0 0 1 2.476-1.128 2.384 2.384 0 0 1 2.2 1.216h.029V18h1.7zm-1.684-2.835v-.973a1.91 1.91 0 0 0-.524-1.352 1.718 1.718 0 0 0-1.309-.56 1.793 1.793 0 0 0-1.512.714 3.217 3.217 0 0 0-.546 2 2.774 2.774 0 0 0 .524 1.769 1.678 1.678 0 0 0 1.387.662 1.805 1.805 0 0 0 1.429-.632 2.391 2.391 0 0 0 .551-1.629zM73.908 25.5h-1.7v-4.227q0-2.1-1.486-2.1a1.622 1.622 0 0 0-1.282.582 2.162 2.162 0 0 0-.5 1.469V25.5h-1.711V18h1.707v1.245h.029a2.673 2.673 0 0 1 2.435-1.421 2.265 2.265 0 0 1 1.868.795 3.57 3.57 0 0 1 .644 2.3zM80.962 16.426a1.02 1.02 0 0 1-.714-.272.89.89 0 0 1-.3-.688.916.916 0 0 1 .3-.7 1.008 1.008 0 0 1 .714-.278 1.039 1.039 0 0 1 .732.278.909.909 0 0 1 .3.7.9.9 0 0 1-.3.678 1.034 1.034 0 0 1-.732.282zM81.8 25.5h-1.7V18h1.7zM90.7 25.5H89v-4.227q0-2.1-1.486-2.1a1.622 1.622 0 0 0-1.282.582 2.157 2.157 0 0 0-.506 1.469V25.5h-1.703V18h1.707v1.245h.03a2.673 2.673 0 0 1 2.431-1.421 2.265 2.265 0 0 1 1.868.795 3.57 3.57 0 0 1 .644 2.3zM106.984 18l-2.212 7.5h-1.78l-1.361-5.083a3.215 3.215 0 0 1-.1-.659h-.031a3.069 3.069 0 0 1-.131.644l-1.48 5.1h-1.744L95.939 18H97.7l1.363 5.405a3.16 3.16 0 0 1 .087.645h.05a3.384 3.384 0 0 1 .117-.659L100.832 18h1.6l1.347 5.428a3.732 3.732 0 0 1 .095.644h.052a3.387 3.387 0 0 1 .11-.644L105.365 18zM109.1 16.426a1.018 1.018 0 0 1-.714-.272.886.886 0 0 1-.3-.688.912.912 0 0 1 .3-.7 1.006 1.006 0 0 1 .714-.278 1.039 1.039 0 0 1 .732.278.912.912 0 0 1 .3.7.9.9 0 0 1-.3.678 1.034 1.034 0 0 1-.732.282zm.841 9.074h-1.7V18h1.7zM116.117 25.42a2.955 2.955 0 0 1-1.31.248q-2.182 0-2.183-2.094v-4.241h-1.253V18h1.253v-1.736l1.7-.483V18h1.794v1.333h-1.794v3.75a1.484 1.484 0 0 0 .241.952 1.006 1.006 0 0 0 .807.285 1.167 1.167 0 0 0 .746-.248zM124.248 25.5h-1.7v-4.1q0-2.226-1.487-2.226a1.556 1.556 0 0 0-1.26.644 2.568 2.568 0 0 0-.513 1.649V25.5h-1.707V14.4h1.707v4.849h.029a2.685 2.685 0 0 1 2.432-1.421q2.5 0 2.5 3.055zM141.907 25.5h-1.728v-6.8q0-.835.1-2.043h-.029a6.992 6.992 0 0 1-.285.988l-3.134 7.855h-1.2l-3.143-7.793a7.236 7.236 0 0 1-.277-1.047h-.029q.057.63.058 2.058V25.5h-1.611V15h2.453l2.762 7a10.884 10.884 0 0 1 .41 1.2h.036c.181-.551.327-.962.44-1.23l2.811-6.97h2.366zM145.158 16.426a1.022 1.022 0 0 1-.714-.272.89.89 0 0 1-.3-.688.916.916 0 0 1 .3-.7 1.009 1.009 0 0 1 .714-.278 1.043 1.043 0 0 1 .733.278.911.911 0 0 1 .3.7.9.9 0 0 1-.3.678 1.038 1.038 0 0 1-.733.282zM146 25.5h-1.7V18h1.7zM153.589 25.156a4.2 4.2 0 0 1-2.131.52 3.606 3.606 0 0 1-2.695-1.044 3.691 3.691 0 0 1-1.026-2.706 4.07 4.07 0 0 1 1.1-2.978 3.944 3.944 0 0 1 2.948-1.124 4.3 4.3 0 0 1 1.81.36v1.582a2.743 2.743 0 0 0-1.67-.586 2.32 2.32 0 0 0-1.766.728 2.665 2.665 0 0 0-.688 1.908 2.536 2.536 0 0 0 .648 1.838 2.3 2.3 0 0 0 1.739.674 2.716 2.716 0 0 0 1.729-.652zM159.625 19.619a1.4 1.4 0 0 0-.887-.242 1.513 1.513 0 0 0-1.259.682 3.04 3.04 0 0 0-.506 1.852V25.5h-1.7V18h1.7v1.545H157a2.606 2.606 0 0 1 .766-1.233 1.724 1.724 0 0 1 1.154-.444 1.432 1.432 0 0 1 .7.14zM164.02 25.676a3.719 3.719 0 0 1-2.773-1.051 3.8 3.8 0 0 1-1.036-2.787 3.7 3.7 0 0 1 3.991-4.014 3.6 3.6 0 0 1 2.739 1.033 3.986 3.986 0 0 1 .982 2.864 3.932 3.932 0 0 1-1.059 2.875 3.8 3.8 0 0 1-2.844 1.08zm.08-6.5a1.938 1.938 0 0 0-1.575.7 2.913 2.913 0 0 0-.579 1.919 2.744 2.744 0 0 0 .586 1.856 1.965 1.965 0 0 0 1.568.678 1.87 1.87 0 0 0 1.542-.666 2.956 2.956 0 0 0 .538-1.9 3 3 0 0 0-.538-1.911 1.858 1.858 0 0 0-1.542-.672zM169.182 25.266v-1.575a3.392 3.392 0 0 0 2.1.725q1.539 0 1.538-.908a.714.714 0 0 0-.132-.436 1.241 1.241 0 0 0-.355-.318 2.784 2.784 0 0 0-.527-.25q-.3-.108-.677-.248a7.052 7.052 0 0 1-.832-.389 2.545 2.545 0 0 1-.615-.465 1.745 1.745 0 0 1-.37-.59 2.145 2.145 0 0 1-.125-.769 1.775 1.775 0 0 1 .256-.955 2.223 2.223 0 0 1 .69-.7 3.289 3.289 0 0 1 .98-.425 4.511 4.511 0 0 1 1.136-.143 5.181 5.181 0 0 1 1.86.315v1.487a3.136 3.136 0 0 0-1.816-.542 2.317 2.317 0 0 0-.582.066 1.472 1.472 0 0 0-.443.183.886.886 0 0 0-.286.282.669.669 0 0 0-.1.363.77.77 0 0 0 .1.41.93.93 0 0 0 .3.3 2.654 2.654 0 0 0 .483.234q.282.105.649.23a9.4 9.4 0 0 1 .867.4 2.886 2.886 0 0 1 .656.465 1.806 1.806 0 0 1 .417.6 2.034 2.034 0 0 1 .147.81 1.847 1.847 0 0 1-.264 1 2.205 2.205 0 0 1-.7.7 3.292 3.292 0 0 1-1.015.413 5.222 5.222 0 0 1-1.212.136 5.115 5.115 0 0 1-2.128-.406zM179.443 25.676a3.717 3.717 0 0 1-2.772-1.051 3.793 3.793 0 0 1-1.036-2.787 3.7 3.7 0 0 1 3.991-4.014 3.6 3.6 0 0 1 2.739 1.033 3.986 3.986 0 0 1 .982 2.864 3.932 3.932 0 0 1-1.059 2.875 3.8 3.8 0 0 1-2.845 1.08zm.08-6.5a1.936 1.936 0 0 0-1.574.7 2.908 2.908 0 0 0-.579 1.919 2.739 2.739 0 0 0 .586 1.856 1.964 1.964 0 0 0 1.567.678 1.868 1.868 0 0 0 1.542-.666 2.95 2.95 0 0 0 .539-1.9 2.99 2.99 0 0 0-.539-1.911 1.857 1.857 0 0 0-1.542-.672zM189.067 15.781a1.533 1.533 0 0 0-.784-.2q-1.237 0-1.237 1.4V18h1.743v1.333h-1.736V25.5h-1.7v-6.167h-1.282V18h1.282v-1.216a2.362 2.362 0 0 1 .777-1.871 2.82 2.82 0 0 1 1.94-.684 2.879 2.879 0 0 1 1 .138zM194.23 25.42a2.955 2.955 0 0 1-1.31.248q-2.182 0-2.183-2.094v-4.241h-1.253V18h1.253v-1.736l1.7-.483V18h1.793v1.333h-1.793v3.75a1.484 1.484 0 0 0 .241.952 1 1 0 0 0 .806.285 1.165 1.165 0 0 0 .746-.248z" />
                  <path
                    className={Styles.socialLogo}
                    fill="#f25022"
                    d="M13 11h9v9h-9z" />
                  <path
                    className={Styles.socialLogo}
                    fill="#00a4ef"
                    d="M13 21h9v9h-9z" />
                  <path
                    className={Styles.socialLogo}
                    fill="#7fba00"
                    d="M23 11h9v9h-9z" />
                  <path
                    className={Styles.socialLogo}
                    fill="#ffb900"
                    d="M23 21h9v9h-9z" />
                </svg>
              </button>
          }
        </div>
        <div className={`${Styles.actions} ${Styles.right} ${Styles._fixed}`}>
          {/* {
            this.props.step != 'preview' &&
            <Button
              className={Styles.button}
              onClick={() => this.props.showModal(MODAL_ADD_ACCOUNT_NAVLIST)}
              value='Back' />
          } */}

          {/* <Button
            className={Styles.button}
            onClick={this.props.onCancel}
            value={t('global.cancel')} /> */}
        </div>
      </form>
    );
  }

  googleConfirmation(loggedinEmail) {
    return (
    <Fragment>
      <p className={`${Styles._loggedDetail} ${Styles._textCenter}`}>
        {`Find the accounts you have signed up to with ${loggedinEmail}`}
      </p>
      <div className={`${Styles.info_packet}`}>
        <div className={`${Styles.info_packet} ${Styles.infoPacketBorder}`}>
          <p className={`${Styles._textColor}`} style={{ paddingLeft: '10px' }}>
            {'The search might take several minutes. No data will leave your device  and access to your inbox will   expire as soon as it is complete.'}
          </p>
          <img className={`${Styles.info_packet_img}`} src={NettoY}></img>
        </div>
      </div>
    </Fragment>
    );
  }

  microsoftConfirmation(loggedinEmail) {
    return (
      <Fragment>
        <p className={`${Styles.emailScanDisclaimer} ${Styles._center} ${Styles._push}`}
        style={{ fontFamily: 'inherit' }}>
          {`Currently signed in email : ${loggedinEmail}`}
        </p>
        <p className={`${Styles.emailScanDisclaimer} ${Styles._center} ${Styles._push}`}>
          {'Continue with this email and find now'}
        </p>
        <p className={`${Styles.emailScanDisclaimer} ${Styles._center} ${Styles._push}`}>
          {'Or logout to sign into a different email'}
        </p>
      </Fragment>
    );
  }

  confirm() {
    const { email, provider, t } = this.props;
    return (
      <form
        action="/"
        className={Styles.formEmailScan}
        method="post"
        onSubmit={this.props.onSubmit}>
        {provider === 'Google' ?
          this.googleConfirmation(email) :
          this.microsoftConfirmation(email)
        }

        <div className={`${Styles.actions}`}>
          <div>
          {provider === 'Microsoft' &&
            <Button
                className={Styles.button}
                onClick={this.props.signOutMicrosoftUser}
                value='Logout' />
          }
          </div>
          <div className={`${Styles.rightAlign1}`}>

            <Button
              className={Styles.findNow}
              type="submit"
              value={'FIND NOW'} />
          </div>
        </div>
      </form>
    );
  }

  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <h1
          aria-label={t('modal.accountAdd.title')}
          className={classNames({
            [Styles.title]: true,
            [Styles.stickyHeaderList]: true,
          })}>
          { this.props.step == 'preview' ? '' : <LeftArrowIcon onClickBackHandler={() => this.props.showModal(MODAL_ADD_ACCOUNT_NAVLIST)} />}
          { this.props.step == 'preview' ? 'Add accounts' : 'Search email'}
          <CancelIcon onCancel={this.props.onCancel} />
        </h1>

        {this.content()}
      </React.Fragment>
    );
  }
}

ModalEmailScanContainer.defaultProps = {
  apps: {},
  disabledTabs: false,
  email: '',
  error: '',
  foundAccounts: 0,
  groupIds: [],
  groups: {},
  hasNewAccounts: false,
  isPaused: false,
  isWaiting: false,
  onBack: noop,
  onCancel: noop,
  onChangeConsent: noop,
  onClickGoogleButton: noop,
  onClickMicrosoftButton: noop,
  onPauseOrResume: noop,
  onSubmit: noop,
  unsortedId: null,
};

ModalEmailScanContainer.propTypes = {
  apps: PropTypes.object,
  canPause: PropTypes.bool,
  canSubmit: PropTypes.bool,
  disabledTabs: PropTypes.bool,
  email: PropTypes.string,
  error: PropTypes.string,
  onClickClearSearch: PropTypes.func,
  foundAccounts: PropTypes.number,
  groupIds: PropTypes.array,
  groups: PropTypes.object,
  hasConsent: PropTypes.bool,
  hasNewAccounts: PropTypes.bool,
  accountAlreadyExists: PropTypes.bool,
  loggedinEmail: PropTypes.string,
  isPaused: PropTypes.bool,
  isWaiting: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  onBack: PropTypes.func,
  onCancel: PropTypes.func,
  onChangeConsent: PropTypes.func,
  onClickGoogleButton: PropTypes.func,
  onClickMicrosoftButton: PropTypes.func,
  onPauseOrResume: PropTypes.func,
  onSelectApp: PropTypes.func,
  onSubmit: PropTypes.func,
  selectedApps: PropTypes.array,
  step: PropTypes.string,
  submitting: PropTypes.bool,
  /** i18n translate method */
  t: PropTypes.func.isRequired,
  unsortedId(props, propName, componentName) {
    const propValue = props[propName];
    if (propValue === null) return;
    if (typeof propValue === 'string') return;
    throw new Error(`${componentName} only accepts null or string.`);
  },
};

export default ModalEmailScanContainer;
